<template>
  <div id="events">
    <!-- Events Filter -->
    <b-form-input
      class="flex-fill"
      type="text"
      ref="filterEvents"
      placeholder="Filter Events"
      v-model="filter">
    </b-form-input>
    <!-- / Events Filter -->

    <!-- Events Table -->
    <b-table
      striped
      hover
      selectable
      stacked="lg"
      small
      show-empty
      select-mode="single"
      sort-by="start_date_time"
      sort-desc
      @row-selected="selectEvent"
      :items="filteredEvents"
      :fields="fields"
      empty-text="No Events to show.">
      <!-- Registration Open -->
      <template
        slot="registration_start_date_time"
        slot-scope="{ item }">
        {{item.display_registration_start_date_time}}
        <b-badge
          v-b-tooltip.hover.bottom
          :title="eventStatus(item).reason"
          :variant="eventStatus(item).class">
          {{eventStatus(item).canRegister ? 'OPEN' : 'CLOSED'}}
        </b-badge>
      </template>
      <!-- / Registration Open -->

      <!-- Event Start -->
      <template
        slot="start_date_time"
        slot-scope="{ item }">
        {{item.display_start_date_time}}
      </template>
      <!-- / Event Start -->

      <!-- Count/Max Registrations -->
      <template
        slot="count_registrations"
        slot-scope="{ item }">
        <span v-if="item.max_registrations === -1">
          Unlimited
        </span>
        <span v-else>
          {{item.count_registrations | number(0) }}
          /
          {{item.max_registrations | number(0) }}
        </span>
      </template>
      <!-- Count/Max Registrations -->

      <!-- Count/Max Waitlist -->
      <template
        slot="count_waitlist"
        slot-scope="{ item }">
        <span v-if="item.max_waitlist === -1">
          Unlimited
        </span>
        <span v-else>
          {{item.count_waitlist | number(0) }}
          /
          {{item.max_waitlist | number(0) }}
        </span>
      </template>
      <!-- Count/Max Waitlist -->
    </b-table>
    <!-- / Events Table -->

    <!-- Create Event Button -->
    <b-button
      class="corner-button shadow"
      type="button"
      variant="success"
      v-if="hasRole('superadmin')"
      @click="$router.push({ name: 'event', params: { eventID: 'new', tab: 'details' } })">
      <font-awesome-icon icon="plus"></font-awesome-icon> Create New Event
    </b-button>
    <!-- / Create Event Button -->
  </div>
</template>

<script>
import _ from 'lodash';
import DataSvc from '../services/data';
import EventBus from '../services/event-bus';
import AppMixin from '../services/app-mixin';

export default {
  name: 'events',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      filter: '',
      events: [],
      fields: [
        {
          key: 'name',
          label: 'Event',
          sortable: true,
        },
        {
          key: 'registration_start_date_time',
          label: 'Registration Opens',
          sortable: true,
        },
        {
          key: 'start_date_time',
          label: 'Event Starts',
          sortable: true,
        },
        {
          key: 'hidden',
          label: 'Private',
          class: 'text-center',
          sortable: true,
          formatter: value => (value ? 'Yes' : ''),
        },
        {
          key: 'count_registrations',
          label: 'Active Roster',
          sortable: true,
          class: 'text-lg-right',
          tdClass: 'sort-padding-diff',
        },
        {
          key: 'count_waitlist',
          label: 'Waitlist',
          sortable: true,
          class: 'text-lg-right',
          tdClass: 'sort-padding-diff',
        },
      ],
    };
  },
  computed: {
    filteredEvents() {
      return _(this.events)
        .filter(o => o.name.toLowerCase().includes(this.filter.toLowerCase()))
        .value();
    },
  },
  methods: {
    selectEvent(selected) {
      const [e] = selected;
      this.goToEvent(e.id);
    },
    getEvents(seasonID) {
      return DataSvc.getEvents(this.loggedInUser.actingOrg.id, seasonID)
        .then((events) => {
          this.events = _.map(events, (e) => {
            const event = _.pick(e, [
              'id',
              'name',
              'start_date_time',
              'display_start_date_time',
              'registration_start_date_time',
              'display_registration_start_date_time',
              'count_registrations',
              'registration_open',
              'waitlist_open',
              'count_registrations',
              'count_waitlist',
              'pricing_packages',
              'event_over',
              'hidden',
              'hidden_code',
              'rosters',
            ]);

            event.max_registrations = e.rosters[0].max_registrations;
            event.max_waitlist = e.rosters[0].max_waitlist;

            return event;
          });
        });
    },
  },
  created() {
    this.showGlobalLoader('Loading events...');

    const initEvents = () => {
      // update events when season changes
      EventBus.$on('acting-season-changed', this.getEvents);

      return this.getEvents(this.loggedInUser.actingSeason.id);
    };

    this.initPromise.then(initEvents).finally(this.hideGlobalLoader);
  },
  destroyed() {
    EventBus.$off('acting-season-changed', this.getEvents);
  },
};
</script>

<style lang="scss">
.tooltip {
  white-space: nowrap;
  width: 300px !important;
}
</style>
